export interface ShareField {
  key: string;
  label: string;
  sensitive?: boolean;
  group: "Identity" | "Contact" | "Address" | "Health" | "Next of kin" | "Documents";
}

export const SHARE_FIELDS: ShareField[] = [
  { key: "full_name", label: "Full name", group: "Identity" },
  { key: "preferred_name", label: "Preferred name", group: "Identity" },
  { key: "date_of_birth", label: "Date of birth", group: "Identity" },
  { key: "nationality", label: "Nationality", group: "Identity" },
  { key: "course", label: "Course", group: "Identity" },
  { key: "email", label: "Email", group: "Contact" },
  { key: "whatsapp_e164", label: "WhatsApp / phone", group: "Contact" },
  { key: "home_address", label: "Home address", group: "Address" },
  { key: "dietary_tags", label: "Dietary requirements", group: "Health" },
  { key: "dietary_notes", label: "Dietary notes", group: "Health" },
  { key: "allergies", label: "Allergies", group: "Health" },
  { key: "allergy_severity", label: "Allergy severity", group: "Health" },
  { key: "medical_notes", label: "Medical notes", sensitive: true, group: "Health" },
  { key: "nok_name", label: "Next of kin — name", sensitive: true, group: "Next of kin" },
  { key: "nok_relationship", label: "Next of kin — relationship", sensitive: true, group: "Next of kin" },
  { key: "nok_whatsapp_e164", label: "Next of kin — phone", sensitive: true, group: "Next of kin" },
  { key: "nok_email", label: "Next of kin — email", sensitive: true, group: "Next of kin" },
  { key: "passport_number", label: "Passport number", sensitive: true, group: "Documents" },
  { key: "passport_expiry", label: "Passport expiry", group: "Documents" },
  { key: "passport_photo", label: "Passport photo", sensitive: true, group: "Documents" },
  { key: "id_photo", label: "ID / student photo", sensitive: true, group: "Documents" },
];

export const SHARE_FIELD_LABELS: Record<string, string> = Object.fromEntries(
  SHARE_FIELDS.map((f) => [f.key, f.label]),
);

export const SHARE_PRESETS: Record<string, { label: string; description: string; fields: string[]; maskPassport: boolean; allowPhotoDownload: boolean }> = {
  hotel: {
    label: "Hotel / accommodation",
    description: "Rooming and catering essentials — no passport number, no photos.",
    fields: [
      "full_name",
      "preferred_name",
      "date_of_birth",
      "nationality",
      "email",
      "whatsapp_e164",
      "dietary_tags",
      "dietary_notes",
      "allergies",
      "allergy_severity",
    ],
    maskPassport: true,
    allowPhotoDownload: false,
  },
  school: {
    label: "Language school enrolment",
    description: "Identity data needed for enrolment, including passport number.",
    fields: [
      "full_name",
      "preferred_name",
      "date_of_birth",
      "nationality",
      "course",
      "email",
      "whatsapp_e164",
      "home_address",
      "passport_number",
      "passport_expiry",
      "nok_name",
      "nok_relationship",
      "nok_whatsapp_e164",
      "nok_email",
    ],
    maskPassport: false,
    allowPhotoDownload: false,
  },
  custom: {
    label: "Custom",
    description: "Pick exactly what to share.",
    fields: ["full_name"],
    maskPassport: true,
    allowPhotoDownload: false,
  },
};
